import React from 'react';
import { useSelector } from 'react-redux';
import { Form, RadioGroup } from 'react-form';
import SimpleRadio from '../../../components/Form/SimpleRadio';

import { createReactFormValidator, required } from '../../../utils/validation';

import styles from '../nuoV2.scss';
import { NewUserOnboardingIDs } from '../../../components/Analytics/testIDConfig';

const TellUsAboutYourselfForm = (props) => {
    const { onSubmit, defaultValues, error, submitting } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { types: { tms: { memberTypes } } } = coreUI;
    const coachOption = { id: 'coach', label: 'I\'m a coach and/or event organizer', value: 'coach' };
    const mainItems = [...memberTypes.slice(0, 2), coachOption];
    const subItems = memberTypes?.slice(2).map(item => ({ ...item, label: item.label?.split(' : ')[1] }));
    const field1 = 'memberTypeId';
    const field2 = 'subTypeId';
    return (
        <Form
            onSubmit={values => onSubmit({ ...values })}
            defaultValues={defaultValues}
        >
            {(formApi) => {
                const { submitForm, values, touched, getWarning, getError } = formApi;
                const fieldTouched = touched[field1] || touched[field2];
                const fieldError = getError(field1) || getError(field2);
                const fieldWarning = getWarning(field1) || getWarning(field2);
                const value1 = values[field1];
                const value2 = values[field2];
                return (
                    <form onSubmit={submitForm}>
                        <div className={`form-group ${styles.radioGroup} row ${(fieldTouched && fieldError) && 'is-invalid'} mb12`}>
                            <div className="col-12">
                                <RadioGroup
                                    field={field1}
                                    validate={createReactFormValidator(required)}
                                    data-testid={`${NewUserOnboardingIDs.TellUsMainItems.component}-${NewUserOnboardingIDs.TellUsMainItems.location}-${NewUserOnboardingIDs.TellUsMainItems.id}`}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            <label className={'mb12 fw500'} data-testid="nuo-v2.tell-us-about-yourself.role-label">
                                                Which best describes you?
                                            </label>
                                            {mainItems.map(({ id, label }) => (
                                                <SimpleRadio
                                                    option={{ value: id, label }}
                                                    field={field1}
                                                    value={value1}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </RadioGroup>
                                {value1 === 'coach' && (
                                    <div className="ml32">
                                        <RadioGroup
                                            field={field2}
                                            validate={createReactFormValidator(required)}
                                            data-testid={`${NewUserOnboardingIDs.TellUsSubItems.component}-${NewUserOnboardingIDs.TellUsSubItems.location}-${NewUserOnboardingIDs.TellUsSubItems.id}`}
                                        >
                                            {subItems.map(({ id, label }) => (
                                                <SimpleRadio
                                                    option={{ value: id, label }}
                                                    field={field2}
                                                    value={value2}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </div>
                                )}
                                {fieldTouched &&
                                    ((fieldError && <div className="invalid-feedback">{fieldError}</div>) ||
                                    (fieldWarning && <div className="warning-feedback">{fieldWarning}</div>))}
                            </div>
                        </div>
                        {error && (
                            <div><span className="error-text" data-testid="nuo-v2.tell-us-about-yourself.error-text">{error}</span></div>
                        )}
                        <div className="row">
                            <div className="form-group col-12 mb0">
                                <button
                                    type="submit"
                                    className={`btn btn-primary btn-xl btn-block text-uppercase ${styles.btn}`}
                                    disabled={submitting}
                                    data-testid={`${NewUserOnboardingIDs.TellUsContinueButton.component}-${NewUserOnboardingIDs.TellUsContinueButton.location}-${NewUserOnboardingIDs.TellUsContinueButton.id}`}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

export default TellUsAboutYourselfForm;
